export default "__VITE_PUBLIC_ASSET__6eb91846__"